import { Component } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import { MaterialTypeServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import getScrollY from '@/utils/scroll'
const mtsp = new MaterialTypeServiceProxy()
const crsp = new CodeRuleServiceProxy()

@Component
export default class MaterialType extends Template {
  // 物料类型
  name = 'MaterialType'
  options = {
    retrieve: mtsp.getPageMaterialType.bind(mtsp),
    // search: mtsp.getWarehouseLocation.bind(mtsp),
    create: mtsp.createMaterialType.bind(mtsp),
    // update: mtsp.updateWarehouseLocation.bind(mtsp),
    delete: mtsp.deleteMaterialType.bind(mtsp)
  }
  acl = {
    create: 'page_business_create_material_type',
    delete: 'page_business_delete_material_type'
  }

  hidden = ['edit','delete']
  showSearch = false // 不显示搜索框
  materialTypeList = []
  disabled = false
  scroll = {}

  get lang() {
    return {
      create: this.$t("page_business_create_material_type"),
      placeholder: this.$t("keyword"),
      search: this.$t("search"),
      delete: this.$t("page_business_delete_material_type"),
    };
  }
  created(){
    this.getCodeRules()
  }
  async getData(
    current = 1,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      size,
    )
    
    let dataLength = records.length;
    let copy = JSON.parse(JSON.stringify(records));
    let needPush = 0;
    if(dataLength < 30) {
      needPush = 30 - dataLength;
      for(var k=0; k<needPush; k++) {
        let obj = {  
          // id: 'none'
        }
        copy.push(obj)  
      }
    }

    this.dataSource = JSON.parse(JSON.stringify(copy));

    this.scroll['y'] = getScrollY('material-info-console',this.dataSource.length)

    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
  }
  async getCodeRules(){
    const res = await crsp.list('MaterialTypeObject')
    let arr = []
    arr = res
    arr.map(item => {
      this.materialTypeList.push({
        label: item.name,
        value: item.id
      })
    })

  }
   async handleChang(val){
    if(val) {
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''})
    }else{
      this.disabled = false
    }
  }

  render() {
    return this.customRender()
  }
  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          {this.ie ? this.extraHeaderAction() : null}
          <a-button
           style={{ marginLeft: "8px" }}
           disabled={this.selectedRowKeys.length < 1}
           onClick={this.printing}
          >
             {this.$t('page_print_code')}
          </a-button>
        </div>
        {/* <div>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: auto!important;"
            v-model={this.keywords}
          ></a-input-search>
        </div> */}
      </div>
    )
  }

  get columns() {
    return [
      {
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fix: 'left',
        width: 80,
        customRender: (text, record) => {
          return (
            record.id &&
            <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                          onConfirm={() => {
                            this.deleteSingleData([record.id])
                          }}
                          okText={this.$t('yes')}
                          cancelText={this.$t('no')}
            >
              <a class="del-color" v-acl={this.getAcl(this.acl.delete)}>
                {this.$t('delete')}
              </a>
            </a-popconfirm>
          )
        }
      },
      { title: this.$t('page_business_material_type_number'), dataIndex: 'code', width: 250, ellipsis: true },
      { title: this.$t('page_business_material_type_name'), dataIndex: 'name', width: 250, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 350, ellipsis: true }
    ]
  }

  get schema() {
    return {
      codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display:this.showDrawer?"none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 128,
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.materialTypeList,
        on: {
          change: this.handleChang
        },
      },
      code: {
        label: this.$t('page_business_material_type_number'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_material_type_number'),
          // maxLength: 48,
          disabled: this.disabled || this.showDrawer
        },
        rules: [
          {
            required: !this.disabled,
            message: this.$t("page_business_enter_material_type_number"),
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      name: {
        label: this.$t('page_business_material_type_name'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_material_type_name'),
          // maxLength: 48
        },
        rules: [
          {
            required: true,
            message: this.$t("page_business_enter_material_type_name"),
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ],
      },
      remark: {
        label: this.$t('remark'),
        type: 'input',
        props: {
          placeholder: this.$t('remark_tips'),
          // maxLength: 48
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ],
      }
    }
  }
}
